'use client';
import { jsx as c } from "react/jsx-runtime";
import * as d from "react";
import { Input as i } from "../input/input.js";
import { Button as m } from "../button/button.js";
import f from "./coupon-variants.js";
const l = d.forwardRef(
  ({ className: p, onApply: e, onRemove: t, isLoading: a, ...o }, r) => {
    const { applyButton: s } = f({
      succeeded: o.succeeded
    }), n = () => {
      e == null || e();
    }, u = () => {
      t == null || t();
    };
    return /* @__PURE__ */ c(
      i,
      {
        ref: r,
        ...o,
        placeholder: "Coupon code",
        invalidMessage: "Incorrect code",
        suffix: /* @__PURE__ */ c(
          m,
          {
            size: "loose",
            variant: "text",
            className: s(),
            onClick: () => o.succeeded ? n : u,
            loading: a,
            children: o.succeeded ? "Remove" : "Apply"
          }
        )
      }
    );
  }
);
l.displayName = "CouponInput";
export {
  l as CouponInput
};
